import React from 'react';
import { Box } from '@mui/material';
import { CONTROL, PRES, TYPE } from '../chrome';

interface PanelRowProps {
  label: string;
  children: React.ReactNode;
  stacked?: boolean;
  htmlFor?: string;
}

const PanelRow: React.FC<PanelRowProps> = ({ label, children, stacked = false, htmlFor }) => {
  if (stacked) {
    return (
      <Box sx={{ mb: 1.5 }}>
        <Box
          component="label"
          htmlFor={htmlFor}
          sx={{ display: 'block', color: PRES.textSecondary, fontFamily: TYPE.ui, ...TYPE.label, mb: 0.75 }}
        >
          {label}
        </Box>
        {children}
      </Box>
    );
  }

  return (
    <Box
      sx={{
        display: 'grid',
        gridTemplateColumns: 'minmax(72px, 38%) 1fr',
        alignItems: 'center',
        minHeight: CONTROL.row,
        columnGap: 1.25,
        mb: 0.5,
      }}
    >
      <Box
        component="label"
        htmlFor={htmlFor}
        sx={{ color: PRES.textSecondary, fontFamily: TYPE.ui, ...TYPE.label }}
      >
        {label}
      </Box>
      <Box sx={{ display: 'flex', justifyContent: 'flex-end', alignItems: 'center', minWidth: 0 }}>
        {children}
      </Box>
    </Box>
  );
};

export default PanelRow;
